// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import 'ie-placeholder'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'//引入store
import './utils/mock'
/*todo axios 请求数据*/
import axios from './utils/axios.js'
// 将API方法绑定到全局
Vue.prototype.$axios = axios
//将接口api文件,挂载到Vue实例上面
import api from './utils/api'
Vue.prototype.api = api
//将转换时间的工具类,挂载到Vue实例上面
import formatTime from './utils/formatTime'
Vue.prototype.formatTime = formatTime

//模拟data
// import Mock from './mock'
// Mock.bootstrap();

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import VueAweSomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAweSomeSwiper)

import ElementUI from 'element-ui'
import './assets/branchTheme/theme/index.css'
Vue.use(ElementUI)
//解决ie9下input框在element ui失去焦点无法获取输入框值
Vue.prototype.changeValue = function(e) {
  return e.target.value;
}

import './assets/reset.css'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.config.productionTip = false

/* eslint-disable no-new */
bld_VM=new Vue({
  el: '#app',
  router,
  store,//使用store
  components: { App },
  template: '<App/>',
  data: {
    keywords: "",
    description: ""
  },
  created() {
    this.short_name=this.$route.params.short_name;
    sessionStorage.setItem('english_short_name',this.short_name);

    this.getSEO();
  },
  methods:{
    getSEO(){
      //获取各个模块的<meta>字段
      this.$axios.post(this.api.index.moduleSeo,{},res =>{
        for(let item of res.data){
          //缓存 seo data
          this.$cookies.remove(this.api.cachePrex+item.itemid);
          this.$cookies.set(this.api.cachePrex+item.itemid, JSON.stringify(item));
        }
      }); 
    }
  }
})


// WEBPACK FOOTER //
// ./src/main.js